import { useEffect, useMemo, useState } from 'react'

import GridPreview from '../../../../../components/GridPreview'
import { handleConvertTagsId } from '../../../../../utils'
import HistoryGridSkeleton from '../../../../istoric/components/HistoryGridSkeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import FiltersPopup from '../../../../istoric/components/FiltersPopup'
import useGetFilters from '../../../../../hooks/useGetAllTags'
import { useAuthContext } from '../../../../../context'
import Select from '@mui/material/Select'
import PremiumLocked from '../../../../../components/Items/Lock'
import MenuItem from '@mui/material/MenuItem'

const AddGridsTab = ({
  availableGrids,
  addGrid,
  isLoading,
  setFiltersPopupOpened,
  difficultyFilters,
  handleSelectDifficulty,
  setFilteredTags,
  filteredCorrect,
  closeModal,
  filtersPopupOpened,
  filteredTags,
  setFilteredCorrect,
  setDifficultyFilters,
  handleSearchValue,
  searchedValue,
  handleChangeChaptersByCourse,
  sources,
  selectedSource,
  handleChangeSource,
  grileTypes,
  handleChangeGrileTypes,
}) => {
  const [renderCount, setRenderCount] = useState(20)
  const { chapters } = useGetFilters()
  const { userDetails } = useAuthContext()

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent =
        window.scrollY / (document.body.offsetHeight - window.innerHeight)
      if (scrollPercent > 0.8) {
        setRenderCount(current => current + 20)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const grids = useMemo(() => {
    const userEmail = userDetails?.email

    return availableGrids
      ?.filter(grid =>
        selectedSource === 'Toate' ? true : grid.source === selectedSource,
      )
      ?.slice(0, renderCount)
      ?.map((grid, index) => {
        return (
          <GridPreview
            isMultipleChoice={grid?.multiple_choice}
            page={grid?.page}
            historyType={0}
            key={`grila-${index}`}
            grilaId={grid?.id}
            cerinta={grid?.json}
            indiciu={grid?.hint}
            explicatie={grid?.explain}
            answer={grid?.correct_answer}
            userAnswer={grid?.choice}
            tags={handleConvertTagsId(grid?.tags, chapters)}
            source={grid?.source}
            difficulty={grid?.difficulty}
            createdByCurrentUser={grid?.creator_email === userEmail}
            colorByDifficulty
            addGrila={addGrid}
          />
        )
      })
  }, [
    availableGrids,
    renderCount,
    selectedSource,
    addGrid,
    chapters,
    userDetails,
  ])

  return (
    <div className="sm:rounded-[20px] sm:p-5 border border-brd-primary relative overflow-x-hidden mt-[10px]  max-w-[800px] !min-h-[80vh] bg-secondary-background rounded p-[10px]">
      {!isLoading ? (
        <div className="flex flex-col w-full justify-center">
          <div className="flex justify-between items-center px-2">
            <input
              value={searchedValue}
              onChange={e => handleSearchValue(e.target.value)}
              className="p-2 rounded-lg w-[55%] h-12 bg-container-background  border border-brd-primary text-over-ternary-background flex items-center justify-center"
              placeholder="Caută..."
            />
            <Select
              className="w-[35%] !text-over-primary-background !border !border-brd-primary !bg-container-background h-12"
              sx={{
                '& .MuiSelect-select': {
                  color:
                    'rgb(var(--text-over-secondary-background)) !important',
                },
              }}
              MenuProps={{
                sx: {
                  '& .MuiPaper-root': {
                    maxHeight: '200px',

                    backgroundColor:
                      'rgb(var(--container-background)) !important',
                    color:
                      'rgb(var(--text-over-secondary-background)) !important',
                  },
                  '& .MuiMenuItem-root': {
                    maxHeight: '200px',
                    backgroundColor: 'rgb(var(--container-background))',
                    color: 'rgb(var(--over-secondary-background)) !important',
                    '&:hover': {
                      backgroundColor: 'rgb(var(--primary))',
                    },
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'rgb(var(--primary)) !important',
                  },
                },
              }}
              formatOptionLabel={option => (
                <div
                  className={`flex md:text-[18px] !text-over-secondary-background  text-[16px] ${
                    option.isDisabled ? 'justify-between' : 'justify-center'
                  }  items-center`}
                >
                  <div></div>
                  <div>{option.label}</div>
                </div>
              )}
              onChange={handleChangeSource}
              value={selectedSource}
              id={'Admitere AC Iasi, 2024'}
              placeholder="Sursa"
            >
              <MenuItem
                key="source-all"
                className="text-over-primary-background capitalize"
                value="Toate"
              >
                Toate
              </MenuItem>
              {sources?.map(source => (
                <MenuItem
                  key={`source-${source.id}`}
                  className="text-over-primary-background capitalize"
                  value={source.name}
                >
                  {source.name}
                </MenuItem>
              ))}
            </Select>
            <FontAwesomeIcon
              className="text-over-secondary-background cursor-pointer"
              icon={faGear}
              onClick={() => {
                setFiltersPopupOpened(true)
              }}
            />
          </div>
          {grids.length === 0 ? (
            <div className="text-over-secondary-background mt-10 flex justify-center">
              Nici o grilă găsită
            </div>
          ) : (
            grids
          )}
        </div>
      ) : (
        <div className="flex px-2 flex-col">
          <div className="flex w-full  justify-between items-center">
            <div className="w-[75%] rounded h-10 bg-secondary-skeleton animate-pulse"></div>
            <div className="w-[30px] h-[30px] rounded bg-secondary-skeleton animate-pulse"></div>
          </div>
          {Array(10)
            .fill(0)
            .map((_, index) => (
              <HistoryGridSkeleton key={index} />
            ))}
        </div>
      )}

      <FiltersPopup
        handleChangeGrileTypes={handleChangeGrileTypes}
        grileTypes={grileTypes}
        initialDifficultyFilters
        setDifficultyFilters={setDifficultyFilters}
        hasSubscription
        handleChangeChaptersByCourse={handleChangeChaptersByCourse}
        difficultyFilters={difficultyFilters}
        handleSelectDifficulty={handleSelectDifficulty}
        filteredTags={filteredTags}
        setFilteredCorrect={setFilteredCorrect}
        setFilteredTags={setFilteredTags}
        filteredCorrect={filteredCorrect}
        closeModal={closeModal}
        filtersPopupOpened={filtersPopupOpened}
      />
    </div>
  )
}

export default AddGridsTab
